import { render, staticRenderFns } from "./RestaurantAdd.vue?vue&type=template&id=6c78573b&scoped=true&"
import script from "./RestaurantAdd.vue?vue&type=script&lang=js&"
export * from "./RestaurantAdd.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantAdd.vue?vue&type=style&index=0&id=6c78573b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78573b",
  null
  
)

export default component.exports